import ReactPlayer from 'react-player';

import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

export const StyledReactPlayer = styled(ReactPlayer, {
  shouldForwardProp: (prop) => prop !== 'styleOverride',
})<{ styleOverride?: React.CSSProperties }>(({ styleOverride }) => ({
  backgroundColor: styleOverride?.backgroundColor,
  width: '100% !important',
  height: '100% !important',

  '& video': {
    width: '100%',
    height: '100%',
    objectFit: styleOverride?.objectFit || 'cover',
  },
}));
